import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

const supportedCurrencies = ['CHF', 'EUR', 'USD', 'GBP'];
const defaultCurrency = 'CHF';
const localeCurrencyMap = {
  'en-US': 'USD',
  'en-GB': 'GBP',
  'de-DE': 'EUR',
  'de-CH': 'CHF'
};

const supportedLanguages = ['de', 'en'];
const languageLocaleMap = {
  en: 'en-US',
  de: 'de-DE'
};
const defaultLanguage = 'de';

@Injectable()
export class SettingsService {
  constructor(private http: Http, private translate: TranslateService) {}

  getSupportedCurrencies(): string[] {
    return supportedCurrencies;
  }

  getCurrency(): string {
    const storedCurrency = this.get('currency');

    if (storedCurrency) {
      return storedCurrency;
    } else {
      const browserLang = this.translate.getBrowserCultureLang();
      return localeCurrencyMap[browserLang] ? localeCurrencyMap[browserLang] : defaultCurrency;
    }
  }

  setCurrency(currency: string) {
    this.set('currency', currency);
  }

  getLanguage(): string {
    const storedLanguage = this.get('language');

    if (storedLanguage) {
      return storedLanguage;
    } else {
      const browserLang = this.translate.getBrowserLang();
      return supportedLanguages.includes(browserLang) ? browserLang : defaultLanguage;
    }
  }

  setLanguage(lang) {
    this.set('language', lang);
  }

  getLocale(): string {
    const lang = this.getLanguage();
    return languageLocaleMap[lang];
  }

  getBrainTreeCompatibleLocale(): string {
    return this.getLocale().replace('-', '_');
  }

  getSupportedLanguages(): string[] {
    return supportedLanguages;
  }

  get(key) {
    return localStorage.getItem(key);
  }

  set(key, value) {
    localStorage.setItem(key, value);
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/services/settings.service.ts